import { Route } from 'react-router-dom';
import CandidateProfile from './CandidateProfile';
import ReferenceSubmit from './ReferenceSubmit';
import OAuthCallback from './Oauthhandle';
import DynamicSuccess from './LoginSuccess';

const getRefmeRoutes = () => {
	return (
		<>
			<Route
				path='oauth-jobadder-success'
				element={<DynamicSuccess provider='jobadder' />}
			/>
			<Route
				path='oauth-bullhorn-success'
				element={<DynamicSuccess provider='bullhorn' />}
			/>
			<Route
				path='oauth-vincere-success'
				element={<DynamicSuccess provider='vincere' />}
			/>
			<Route
				path='oauth-jobadder'
				element={<OAuthCallback provider='jobadder' />}
			/>
			<Route
				path='oauth-bullhorn'
				element={<OAuthCallback provider='bullhorn' />}
			/>
			<Route
				path='oauth-vincere'
				element={<OAuthCallback provider='vincere' />}
			/>
			<Route
				path='refme'
				element={<CandidateProfile />}
			/>
			<Route
				path='referenceSubmitted'
				element={<ReferenceSubmit />}
			/>
		</>
	);
};

export default getRefmeRoutes;
